import React from "react";
import styled from "styled-components";
import Paragraph from "antd/es/typography/Paragraph";
import Text from "antd/es/typography/Text";
import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import AssignProductsForm from "../../forms/AssignProductsForm/AssignProductsForm";
import FloatingSummary from "../FloatingSummary/FloatingSummary";
import useIsMobile from "../../../../hooks/useIsMobile";
import { isEmpty } from "lodash";

const Container = styled.div`
  padding-bottom: 100px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
  padding-left: 10px;
  padding-right: 10px;
`;

const FormContainer = styled.div`
  flex: 1;
`;

const SelectedProductsLabel = styled(Text)`
  display: block;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 500;
`;

const AssignProductsBuilder = ({
  formController,
  handleOnFinish,
  initialFormData,
  handleOnSubmitAssign,
  handleOnClick,
  pricingData,
  isPricingFetching,
  quoteSummary,
  itemsLength,
  selectedProducts,
  isButtonEnabled,
  discounts,
}) => {
  const { t } = useTranslation("shop");
  const isMobile = useIsMobile();

  return (
    <Container>
      <Body>
        <FormContainer>
          <div style={{ marginBottom: 32 }} role="region" aria-labelledby="assign-instructions">
            <Title
              id="assign-instructions"
              level={4}
              style={{ marginBottom: 8, fontSize: 18, marginTop: 0 }}
            >
              {t("assign.description")}
            </Title>
            <Paragraph
              type="secondary"
              style={{ fontSize: 14, marginBottom: 0, lineHeight: 1.6 }}
              aria-describedby="assign-instructions"
            >
              {t("assign.instructionalText")}
            </Paragraph>
          </div>

          {!isEmpty(initialFormData.productsDetail) && (
            <SelectedProductsLabel>
              {t("selectedProducts")}:
            </SelectedProductsLabel>
          )}
          <AssignProductsForm
            formController={formController}
            handleOnFinish={handleOnFinish}
            initialFormData={initialFormData}
            handleOnSubmitAssign={handleOnSubmitAssign}
          />
        </FormContainer>
        {!isMobile && (
          <div
            style={{
              width: "40%",
              paddingTop: 30,
              paddingLeft: 40,
              marginRight: 15,
            }}
          >
            <FloatingSummary
              visible={true}
              itemsLength={itemsLength}
              pricingData={pricingData}
              period={quoteSummary?.period}
              selectedProducts={selectedProducts}
              isPricingFetching={isPricingFetching}
              expandedDefault
              expandable={false}
              offset={{
                offsetTop: 120,
              }}
              onActionClick={handleOnClick}
              isButtonEnabled={isButtonEnabled}
              discounts={discounts}
            />
          </div>
        )}
      </Body>
    </Container>
  );
};

export default AssignProductsBuilder;
